import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, UserCheck } from 'lucide-react';
import ProgressBar from './ProgressBar';
import Pill, { difficultyLabel } from './Pill';
import { relativeTime } from '../utils/format';
import '../../../styles/parentPortal.css';

export default function CourseRow({ studentId, course }) {
  const lessons = course.lessonCount || 0;
  const completed = course.completedLessonCount || 0;
  const lastActive = course.lastActivityAt ? relativeTime(course.lastActivityAt) : null;
  return (
    <Link
      to={`/family/students/${encodeURIComponent(studentId)}/courses/${encodeURIComponent(course.courseId)}`}
      className="pp-card--interactive"
      style={{
        textDecoration: 'none',
        padding: 'var(--space-4)',
        color: 'var(--text-primary)',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 'var(--space-3)' }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 'var(--space-2)',
              marginBottom: 'var(--space-2)',
              flexWrap: 'wrap',
            }}
          >
            <span
              style={{
                fontSize: 'var(--text-panel-size)',
                fontWeight: 'var(--text-panel-weight)',
                color: 'var(--text-primary)',
              }}
            >
              {course.title}
            </span>
            <Pill>{difficultyLabel(course.difficulty)}</Pill>
            {course.assignedByParent && (
              // Neutral, not green — "who assigned this" is a category
              // label, not progress/completion (spec rule 1).
              <Pill tone="neutral">
                <UserCheck size={11} strokeWidth={1.5} />
                Parent-assigned
              </Pill>
            )}
          </div>

          <div style={{ marginBottom: 'var(--space-3)' }}>
            <ProgressBar percent={course.progressPercent} />
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              gap: 'var(--space-3)',
              fontSize: 12,
              color: 'var(--text-tertiary)',
              flexWrap: 'wrap',
            }}
          >
            <span>
              {completed} of {lessons} lessons · {course.progressPercent ?? 0}%
            </span>
            {course.nextLessonTitle && completed < lessons && (
              <span
                style={{
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  maxWidth: '60%',
                }}
                title={`Up next: ${course.nextLessonTitle}`}
              >
                Up next: {course.nextLessonTitle}
              </span>
            )}
            {lastActive && <span>Last active {lastActive}</span>}
          </div>
        </div>

        <ChevronRight
          size={20}
          strokeWidth={1.5}
          style={{ color: 'var(--text-tertiary)', flexShrink: 0, marginTop: 2 }}
        />
      </div>
    </Link>
  );
}
